import loadable from '@loadable/component';

export const CmsRecentSalariesBlockLoadable = loadable(
  () => import('./CmsRecentSalariesBlock'),
  { resolveComponent: (module) => module.CmsRecentSalariesBlock },
);
